import { html } from "./html";
import { css } from "./css";
import { javascript } from "./javascript";
import {} from "./typescript";
import { dart } from "./dart";
import { python } from "./python";
import { react } from "./react";
import {} from "./next";
import { flutter } from "./flutter";
import {} from "./firebase";
import {} from "./docker";
import { node } from "./node";
import {} from "./mongodb";
import {} from "./gcp";
import {} from "./github";
import { mail } from "./mail";
import { phone } from "./phone";
import { linkedIn } from "./linkedin";
import { instagram } from "./instagram";
import { arrow } from "./arrow";
import { close } from "./close";
import { burgerMenu } from "./burger-menu";

export const icons = Object.freeze({
  html,
  css,
  javascript,
  dart,
  python,
  react,
  flutter,
  node,
  mail,
  phone,
  linkedIn,
  instagram,
  arrow,
  close,
  burgerMenu,
});
